import React, { useState } from "react";
import { Col, ProgressBar, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../../components/common/NoDataFound";
import StarRating from "../../../components/common/StarRating";
import calender from "../../../assets/images/icons/calendar.svg";
import upDownArrow from "../../../assets/images/icons/upDownArrow.svg";
import { ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { spaceTypeOptions } from "components/constants/DropdownOptions";
import { getRelativeTimeFromNow, handleStopPropagation } from "components/common/Utils";
import { orderStatusTypes } from "components/constants/StatusKeys";

const ReviewHistory = ({ ratingDashboardDetails }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [dates, setDates] = useState(null);
  // const [selectedBranches, setSelectedBranches] = useState([]);
  // const [sortBy, setSortBy] = useState(1);

  // const handleBranchApply = () => {
  //   console.log(selectedBranches);
  // };

  // const handleSelectionChange = (newSelected) => {
  //   setSelectedBranches(newSelected);
  // };

  return (
    <React.Fragment>
      <Col lg={12} className="review_history">
        <div className="g_between">
          <h2 className="fs_20">{t("Review History")}</h2>
          {/* <div className="d-flex gap-3">
            <Dropdown
              value={sortBy}
              onChange={(e) => setSortBy(e.value)}
              options={sortByOptions}
              optionLabel="name"
              placeholder={t("Sort By")}
              className="custom_dropdown"
              checkmark={true}
              highlightOnSelect={false}
            />
            <BranchDropdown
              data={branchData}
              label={t("Select Branches")}
              allLabel={t("Choose All Branches")}
              resetLabel={t("Reset all")}
              onSelectionChange={handleSelectionChange}
              selectedData={selectedBranches}
              handleApply={handleBranchApply}
            />
            <DateRangePicker dates={dates} setDates={setDates} />
          </div> */}
        </div>
        <Row className="mt-4 px-3">
          <Col lg={4}>
            <h2 className="fs_50">
              {ratingDashboardDetails?.averageRating?.toFixed(1) ?? 0}
            </h2>
            <StarRating
              rating={ratingDashboardDetails?.averageRating ?? 0}
              //   starRatedColor={item?.rating > 2 ? "#C4D26E" : "#FF6363"}
            />
            <p className="fs_14 text_gray mt-3">
              ({ratingDashboardDetails?.totalRatings} {t("Reviews")})
            </p>
          </Col>
          <Col lg={8}>
            {ratingDashboardDetails?.stars?.map((rating) => (
              <div className="d-flex gap-4">
                <h6 className="fs_12 w_fit_content">
                  {rating.value} {t("Star")}
                </h6>
                <div className="w-100 custom_progressbar">
                  <ProgressBar
                    now={rating.percent}
                    className={rating.value === 1 ? "negative_rating" : ""}
                  />
                </div>
                <h6 className="fs_12">{rating.count}</h6>
              </div>
            ))}
          </Col>
        </Row>
      </Col>
      <Col lg={12} className="my-3">
        <div className="common_table_style">
          {ratingDashboardDetails?.recentReviews?.length === 0 ? (
            <NoDataFound />
          ) : (
            <Table>
              <thead className="t_head">
                <tr>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <img src={calender} alt="icon" width={16} height={16} />
                      {t("Date")}
                    </div>
                  </th>
                  <th>{t("Status")}</th>
                  <th>{t("Booking No")}</th>
                  <th>{t("User")}</th>
                  <th>{t("Number")}</th>
                  <th>{t("Booking")}</th>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={upDownArrow}
                        alt="icon"
                        width={16}
                        height={16}
                      />
                      {t("Rating")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {ratingDashboardDetails?.recentReviews?.map((item) => (
                  <tr
                    key={item._id}
                    onClick={() =>
                      navigate(
                        `/bookings/bookings/booking-details?id=${item?.booking?._id}`
                      )
                    }
                    className="c_p"
                  >
                    <td>
                      <p className="w_fit_content">
                        {getRelativeTimeFromNow(item?.createdAt || "-")}
                      </p>
                    </td>
                    <td>
                      <p
                        className={
                          orderStatusTypes?.find(
                            (option) =>
                              option?.value === item?.booking?.bookingStatus
                          )?.class
                        }
                      >
                        {t(
                          orderStatusTypes?.find(
                            (option) =>
                              option?.value === item?.booking?.bookingStatus
                          )?.name
                        )}
                      </p>
                    </td>
                    <td>#{item?.booking?.bookingNo || "-"}</td>
                    <td onClick={handleStopPropagation}>
                      <Link
                        to={`/customers/customer-information?id=${item?.user?._id}`}
                        className="text_primary text-decoration-underline"
                      >
                        {item?.user?.name || "-"}
                      </Link>
                    </td>
                    <td>{item?.user?.phone || "-"}</td>
                    <td style={{ minWidth: 175 }}>
                      {t(
                        spaceTypeOptions?.find(
                          (option) => option.value === item?.space?.spaceType
                        )?.name
                      )}{" "}
                      {"-"} {item?.space?.name}
                      <p className="fs_12 text_gray">
                        {item?.space?.city?.name}, {item?.space?.branch?.name}
                      </p>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        {item?.rating || "-"}
                        <StarRating
                          rating={item?.rating}
                          starRatedColor={
                            item?.rating > 2 ? "#C4D26E" : "#FF6363"
                          }
                        />
                      </div>
                      <p className="fs_14 mt-2" style={{ minWidth: 200 }}>
                        {item?.feedback || "-"}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button
            onClick={() => navigate("/dashboards/reviews/review-history")}
            className="see_all transparent_btn"
          >
            {t("See All")} <ChevronRight />
          </button>
        </div>
      </Col>
    </React.Fragment>
  );
};

export default ReviewHistory;
